import axios from "axios";
import { baseURL, soapNotes, superTailsUrl } from "./../../util/server";

function headerConfig(contentType, auth, formData) {
  const header = {};

  if (contentType && typeof contentType === "string") {
    header["Content-Type"] = contentType;
  } else {
    header["Content-Type"] = "application/json";
  }

  if (formData === true) {
    header["Content-Type"] = "multipart/form-data";
  }

  if (auth === true) {
    const token = localStorage.getItem("accessToken");
    header.Authorization = `Bearer ${token}`;
  }

  return header;
}

export default ({ contentType, auth, formData }) =>
  axios.create({
    baseURL,
    headers: headerConfig(contentType, auth, formData),
  });

export const chatgptApi = axios.create({
  baseURL: "https://api.openai.com",
  headers: {
    Authorization: `Bearer ${process.env.REACT_APP_GPT_KEY}`, // Add your API key here
    "Content-Type": "application/json",
  },
});

export const soapApi = axios.create({
  baseURL: soapNotes,
  headers: {
    "Content-Type": "multipart/form-data",
    Accept: "application/json",
  },
});

export const soapApiJson = axios.create({
  baseURL: soapNotes,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

export const superTailsApi = axios.create({
  baseURL: superTailsUrl,
  headers: {
    // Authorization: `Bearer ${api_key}`, // Add your API key here
    "Content-Type": "application/json",
  },
});
